import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_2 = { class: "col-1 mt-3 mb-3" }
const _hoisted_3 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_6 = { class: "visually-hidden" }
const _hoisted_7 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  key: 2,
  class: "row"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = {
  key: 0,
  class: "col-xl-10 col-12 mt-3"
}
const _hoisted_12 = { class: "row mb-2" }
const _hoisted_13 = {
  class: "col-12",
  style: {"text-align":"left"}
}
const _hoisted_14 = { style: {"font-weight":"bold"} }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "form-check form-check-inline" }
const _hoisted_17 = ["id", "onClick", "tabindex"]
const _hoisted_18 = ["for"]
const _hoisted_19 = {
  key: 1,
  class: "col-xl-10 col-12 mt-3"
}
const _hoisted_20 = { class: "row mb-2" }
const _hoisted_21 = {
  class: "col-12",
  style: {"text-align":"left"}
}
const _hoisted_22 = { style: {"font-weight":"bold"} }
const _hoisted_23 = {
  class: "fw-bold",
  style: {"text-align":"left"}
}
const _hoisted_24 = { class: "form-check location-name-container" }
const _hoisted_25 = ["id", "onClick", "checked"]
const _hoisted_26 = ["for"]
const _hoisted_27 = {
  key: 0,
  class: "location-data-container p-3 row"
}
const _hoisted_28 = { class: "col-12 col-md-6 pb-2" }
const _hoisted_29 = {
  class: "mt-2 location-address-label",
  style: {"text-align":"left"}
}
const _hoisted_30 = {
  class: "location-city",
  style: {"text-align":"left"}
}
const _hoisted_31 = {
  class: "location-address",
  style: {"text-align":"left"}
}
const _hoisted_32 = { class: "col-12 col-md-6" }
const _hoisted_33 = {
  class: "mt-2 location-openhours-label",
  style: {"text-align":"left"}
}
const _hoisted_34 = {
  class: "table table-borderless table-sm",
  style: {"text-align":"left"}
}
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = {
  key: 2,
  class: "col-12"
}

import { onMounted, ref, inject, onUnmounted, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import { useTenantConfig } from "../../composables/useTenantConfig";
import api from "@/services/BookingService";
import _ from "lodash";
import { LocationModel } from "@/models/Step/LocationModel";
import { useI18n } from "vue-i18n";
import constants from "@/models/Utils/constants";
import { RoomLocationResponse } from "@/models/Responses/RoomLocationResponse";
import { LocationScheduleItem, LocationScheduleItemDescription } from "@/models/Location/LocationScheduleItem";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookLocation',
  setup(__props) {

const { getSelectionMode, getWebLabel } = useTenantConfig();
const router = useRouter();
const store = useStore();
const { t } = useI18n();
const emitter = inject<any>("emitter");

const selectedItem = ref(null);
const selectedLocationType = ref(null);
const loading = ref(false);
const loadingConfig = ref(false);
const serviceNotSet = ref(false);
const rooms = ref(null);
const locations = ref<RoomLocationResponse[]>([]);
const locationTypes = ref([]);
const replaceRouteNavigation = ref(false);

onMounted(() => {
    loadingConfig.value = true;

    emitter.on(constants.GO_NEXT_STEP, () => {
        goToNextStep();
    });

    // Se non è stato impostato il servizio (magari query string errata), mostro msg di errore

    if (store.stepsMade && store.stepsMade.service) {
        loadingConfig.value = false;
        getData();
        store.stepsMade.location = null;
    } else {
        serviceNotSet.value = true;
        loadingConfig.value = false;
    }
});

watch(
    () => selectedItem.value,
    (newVal) => {
        if (newVal) {
            emitter.emit(constants.CAN_GO_NEXT_STEP, true);
        } else {
            emitter.emit(constants.CAN_GO_NEXT_STEP, false);
        }
    },
    { immediate: true }
);

const getData = () => {
    loading.value = true;

    const serviceIds: number[] = [];
    serviceIds.push(parseInt(store.stepsMade.service.id));

    // imposto il filtro comuni sia se selezionato dall'utente che se impostato da query string...altrimenti niente
    let comuni: string[] = [];
    // Per prima cosa guardo se è stato selezionato il comune dall'utente (nel caso fosse abilitata la selezione)
    if (store.stepsMade && store.stepsMade.municipality) {
        comuni.push(store.stepsMade.municipality);
    }
    // altrimenti guardo se mi è stato passato come filtro nella query string
    else if (store.municipalityFilter && store.municipalityFilter.length > 0) {
        comuni = store.municipalityFilter;
    }

    api.getLocations(store.tenantSelected.id, serviceIds, comuni, store.roomTypeFilter)
        .then((result) => {
            if (_.isNull(result) === false && _.isUndefined(result) === false) {
                if (_.isNull(result.data) === false && _.isUndefined(result.data) === false && _.isArray(result.data) && result.data.length > 0) {
                    rooms.value = result.data;

                    if (rooms.value.length > 0) {
                        //extract the locations
                        const roomlocations: RoomLocationResponse[] = rooms.value.map(function (item: {
                            location: {
                                id: string;
                                name: string;
                                roomType: number;
                                city: string;
                                address: string;
                                schedules: LocationScheduleItem[];
                            };
                        }) {
                            const location = new RoomLocationResponse();
                            location.id = item.location.id;
                            location.name = item.location.name;
                            location.roomType = item.location.roomType;
                            location.city = item.location.city;
                            location.address = item.location.address;
                            location.schedules = item.location.schedules;
                            return location;
                        });

                        const uniqLocation = _.uniqBy(roomlocations, function (item: RoomLocationResponse) {
                            return item.id;
                        });

                        locations.value = uniqLocation;
                        populateLocationTypes();

                        // if (uniqLocation.length === 1 && uniqLocation[0].roomType === 2) {
                        //     setLocation(uniqLocation[0], true);
                        //     goToNextStep();
                        // } else {
                        //     locations.value = uniqLocation;
                        //     populateLocationTypes();
                        // }
                    }
                }
            }

            loading.value = false;
        })
        .catch((err: any) => {
            console.log("Errore nella get delle room");
            loading.value = false;
        });
};

const isItemSelected = (locationId: string) => {
    if (_.isNull(selectedItem.value) === false) {
        if (selectedItem.value.id === locationId) {
            return true;
        }
    }
    return false;
};

const isLocationTypeSelected = (locationTypeId: string) => {
    if (_.isNull(selectedLocationType.value) === false) {
        if (selectedLocationType.value.id === locationTypeId) {
            return true;
        }
    }
    return false;
};

const bookEditHasSameLocation = (locationId: string) => {
    if (_.isNull(store.bookedit) === false && store.bookedit.room && store.bookedit.room.location && store.bookedit.room.location.id) {
        if (store.bookedit.room.location.id === locationId) {
            return true;
        }
    }
    return false;
};

const setLocation = (locationRoom: RoomLocationResponse, replaceRoute = false) => {
    if (_.isNull(locationRoom) === false) {
        const location = new LocationModel();
        location.id = locationRoom.id;
        location.name = locationRoom.name;
        location.roomType = locationRoom.roomType;
        location.city = locationRoom.city;
        selectedItem.value = location;
        replaceRouteNavigation.value = replaceRoute;
    }
};

const setLocationType = (locationType: any) => {
    selectedItem.value = null;
    if (_.isNull(locationType) === false) {
        selectedLocationType.value = locationType;

        let locationtypeId = parseInt(selectedLocationType.value.id.split("_")[1]);
        const locationsFiltered = _.filter(locations.value, function (o) {
            return o.roomType === locationtypeId;
        });

        if (locationsFiltered.length == 1) {
            let loc = locationsFiltered[0];

            setLocation(loc);
        }
    }
};

const populateLocationTypes = () => {
    locationTypes.value = [];
    let locationTypesTemp: any[] = [];
    if (locations.value && locations.value.length > 0) {
        const uniqLocationTypes = _.uniqBy(locations.value, function (item: RoomLocationResponse) {
            return item.roomType;
        });

        uniqLocationTypes.forEach((element) => {
            var description = "";
            switch (element.roomType) {
                case 0:
                    description = getWebLabel.value ? getWebLabel.value["locationVirtual"] : t("common.locationVirtual");
                    break;
                case 1:
                    description = getWebLabel.value ? getWebLabel.value["locationPhysical"] : t("common.locationPhysical");
                    break;
                case 2:
                    description = getWebLabel.value ? getWebLabel.value["locationOnline"] : t("common.locationOnline");
                    break;
                default:
                    break;
            }
            locationTypesTemp.push({ id: "roomtype_" + element.roomType.toString(), value: description });
        });

        locationTypes.value = locationTypesTemp.sort((a, b) => (a.roomType > b.roomType ? 1 : b.roomType > a.roomType ? -1 : 0));
    }

    if (locationTypes.value.length === 1) {
        setLocationType(locationTypes.value[0]);
    }
};

const populateLocationHours = (days: LocationScheduleItem[]) => {
    let retDays: LocationScheduleItemDescription[] = [];
    if (days) {
        days.forEach((d) => {
            let hourDesc = d.hours.map((h) => `${h.fromTime} - ${h.toTime}`);
            retDays.push({ day: convertIntDayToDescription(d.dayOfWeek), hours: hourDesc.join(" / ") });
        });
    }
    return retDays;
};

const convertIntDayToDescription = (dayInt: number) => {
    let stringToRet = "";
    switch (dayInt) {
        case 0:
            stringToRet = t("common.daySunday");
            break;
        case 1:
            stringToRet = t("common.dayMonday");
            break;
        case 2:
            stringToRet = t("common.dayTuesday");
            break;
        case 3:
            stringToRet = t("common.dayWednesday");
            break;
        case 4:
            stringToRet = t("common.dayThursday");
            break;
        case 5:
            stringToRet = t("common.dayFriday");
            break;
        case 6:
            stringToRet = t("common.daySaturday");
            break;

        default:
            return "";
    }

    return stringToRet;
};

const locationsForSelectedType = computed(() => {
    if (locations.value && selectedLocationType.value) {
        let locationtypeId = parseInt(selectedLocationType.value.id.split("_")[1]);
        const locationsFiltered = _.filter(locations.value, function (o) {
            return o.roomType === locationtypeId;
        });
        return locationsFiltered;
    }
    return [];
});

const goToNextStep = () => {
    store.stepsMade.location = selectedItem.value;
    const dateSelectionMode = getSelectionMode("dateselection.web");
    if (replaceRouteNavigation.value) {
        if (dateSelectionMode == "nextxdays") {
            router.replace({ name: "bookdate" });
        } else if (dateSelectionMode == "nextxdayshour") {
            router.replace({ name: "bookdatehour" });
        } else {
            router.replace({ name: "bookmonth" });
        }
    } else {
        if (dateSelectionMode == "nextxdays") {
            router.push({ name: "bookdate" });
        } else if (dateSelectionMode == "nextxdayshour") {
            router.push({ name: "bookdatehour" });
        } else {
            router.push({ name: "bookmonth" });
        }
    }
};

const isRoomOnlineType = computed(() => {
    if (isItemSelected && selectedItem.value && selectedItem.value.roomType == 2) {
        return true;
    }

    return false;
});

onUnmounted(() => emitter.off(constants.GO_NEXT_STEP));

return (_ctx: any,_cache: any) => {
  return (loading.value || loadingConfig.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("common.loadingText")), 1)
          ])
        ])
      ]))
    : (serviceNotSet.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)("messages.noServiceSelected")), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h2", null, _toDisplayString(_unref(t)("titles.selectLocation")), 1)
          ]),
          (locationTypes.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(t)("titles.selectLocationType")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationTypes.value, (locationType, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-md-4 col-12",
                      style: {"text-align":"left"},
                      key: locationType.id
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("input", {
                          name: "gruppoLocationType",
                          type: "radio",
                          id: locationType.id,
                          onClick: ($event: any) => (setLocationType(locationType)),
                          tabindex: index
                        }, null, 8, _hoisted_17),
                        _createElementVNode("label", {
                          class: _normalizeClass(["labelblack", [isLocationTypeSelected(locationType.id) ? 'fw-semibold' : '']]),
                          for: locationType.id
                        }, _toDisplayString(locationType.value), 11, _hoisted_18)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (selectedLocationType.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)("titles.selectLocationDetail")), 1)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationsForSelectedType.value, (location) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["location-list", selectedItem.value && location.id == selectedItem.value.id ? 'primary-border-color' : '']),
                    key: location.id,
                    style: _normalizeStyle([{ 'border-width': selectedItem.value && location.id == selectedItem.value.id ? '2px' : '' }, { 'border-style': selectedItem.value && location.id == selectedItem.value.id ? 'solid' : '' }])
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("input", {
                          name: "gruppoLocation",
                          type: "radio",
                          id: location.id,
                          onClick: ($event: any) => (setLocation(location)),
                          checked: selectedItem.value && location.id == selectedItem.value.id
                        }, null, 8, _hoisted_25),
                        _createElementVNode("label", {
                          class: _normalizeClass(["labelblack mb-0", [isItemSelected(location.id) ? 'fw-semibold' : '']]),
                          for: location.id
                        }, _toDisplayString(location.name), 11, _hoisted_26)
                      ])
                    ]),
                    (!isRoomOnlineType.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)("common.address")), 1),
                            _createElementVNode("div", _hoisted_30, _toDisplayString(location.city), 1),
                            _createElementVNode("div", _hoisted_31, _toDisplayString(location.address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(t)("common.openHours")), 1),
                            _createElementVNode("table", _hoisted_34, [
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(populateLocationHours(location.schedules), (item, key) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                    _createElementVNode("td", {
                                      innerHTML: item.day
                                    }, null, 8, _hoisted_35),
                                    _createElementVNode("td", null, _toDisplayString(item.hours), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 6))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!loading.value && locations.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("label", null, _toDisplayString(_unref(t)("messages.noLocationFound")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
}
}

})